import { queryParams, routes } from "routes";
import * as Sentry from "@sentry/browser";
import { isAppInViewMode, isAppInProofViewMode, getAppVersion, isPwaApp } from "@kubera/common";
import { getClaritySessionUrl } from "logger/ConfigureLogger";

export const MOBILE_PWA_POPUP_BYPASS_KEY = "MOBILE_PWA_POPUP_BYPASS_KEY";

export const category = {
  ASSET: "Asset",
  DEBT: "Debt",
  INSURANCE: "Insurance",
  ALL: "All"
};

// The default net worth dashboard needs 1010px of content plus the 222px sidebar
// and, on classic-scrollbar platforms (Windows/Linux), the 14px scrollbar — a
// 1246px viewport. Below that (11" iPads in landscape are 1180-1210px) the layout
// compresses to the smallest 11" iPad content area: 1180 - 222 = 958px, leaving
// (958 - 2x5 content padding - 2x5 column margins) / 2 = 469px per chart column.
export const narrowDashboardLayout = {
  MEDIA_QUERY: "screen and (max-width: 1245px)",
  CONTENT_MIN_WIDTH: 958,
  CHART_COLUMN_WIDTH: 469
};

const staticMethods = {
  showPortfolio: (history, location, portfolioId) => {
    history.push({
      ...location,
      hash: "",
      search: `${queryParams.PORTFOLIO_ID}=${portfolioId}`
    });
  },

  openPortfolio: portfolioId => {
    const url = new URL(window.location.href);
    url.hash = "";
    url.searchParams.set(queryParams.PORTFOLIO_ID, portfolioId);

    if (isPwaApp()) {
      window.location = url.toString();
      return;
    }
    window.kuberaOpen(url.toString());
  },

  getCurrentCategory: () => {
    const pathName = window.location.pathname;
    if (pathName.includes(routes.ASSETS)) {
      return category.ASSET;
    } else if (pathName.includes(routes.DEBTS)) {
      return category.DEBT;
    }
    return null;
  },

  getPathnameForCategory: categoryName => {
    if (categoryName === category.ASSET) {
      return routes.ASSETS;
    } else if (categoryName === category.DEBT) {
      return routes.DEBTS;
    }
    return null;
  },

  trackSession: (userId, user, sessionURL = window.location.href) => {
    if (isAppInViewMode() === false && isAppInProofViewMode() === false) {
      window.Beacon("identify", {
        name: user.name,
        email: user.email,
        user_id: user.id,
        created_at: user.tsCreated,
        sessionURL: sessionURL,
        appVersion: getAppVersion()
      });
    }

    const scope = Sentry.getCurrentScope();
    scope.setUser({
      id: userId
    });
    scope.setExtra("sessionURL", sessionURL);
    const claritySessionUrl = getClaritySessionUrl();
    if (claritySessionUrl) {
      scope.setExtra("claritySessionUrl", claritySessionUrl);
    }
    scope.setExtra("appVersion", getAppVersion());
  }
};

export default staticMethods;
